import React from 'react';
import {
  Navbar,
  InterestsView,
  Schedule,
  Meetings,
  HelpSectionView,
  Pricings,
  IntegrationsView,
  SocialProofView,
  FaqsView,
  Footer,
} from './Components';

const LandingPage = () => {
  return (
    <div>
      <Navbar />
      <div className="landing-page-content">
        <div id="home"><InterestsView /></div>
        <div id="how-it-works"><Schedule /></div>
        <div id="features"><Meetings /></div>
        <HelpSectionView />
        <Pricings />
        <IntegrationsView />
        <SocialProofView />
        <FaqsView />
        <Footer />
      </div>
    </div>
  );
};

export default LandingPage;
